import { Routes } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { PrivateComponent } from './private/private.component';
import { AuthGoogleService } from './services/auth-google.service';
import { NoAccountComponent } from './no-account/no-account.component';
import { EmailAuthComponent } from './email-auth/email-auth.component';

export const routes: Routes = [
  { path: '', redirectTo: '/login', pathMatch: 'full' },
  { path: 'main', component: PrivateComponent, canActivate: [AuthGoogleService] },
  { path: 'login', component: LoginComponent },
  { path: 'noaccount', component: NoAccountComponent },
  { path: 'email-auth', component: EmailAuthComponent }
];
